import { useMemo } from 'react';
import PropTypes from 'prop-types';
import usePromiseState from './hook';

var PromiseStatus = function PromiseStatus(_ref) {
  var promise = _ref.promise,
      thresholdMs = _ref.thresholdMs,
      onSettleDelayMs = _ref.onSettleDelayMs,
      onSettle = _ref.onSettle,
      statusMap = _ref.statusMap,
      children = _ref.children;
  var promiseState = usePromiseState(promise, {
    statusMap: statusMap,
    thresholdMs: thresholdMs,
    onSettle: onSettle,
    onSettleDelayMs: onSettleDelayMs
  });
  var renderedChildren = useMemo(function () {
    return children(promiseState);
  }, [children, promiseState]);
  return renderedChildren;
};

PromiseStatus.propTypes = {
  promise: PropTypes.object,
  children: PropTypes.func.isRequired,
  thresholdMs: PropTypes.number,
  onSettleDelayMs: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  onSettle: PropTypes.func,
  statusMap: PropTypes.object
};
export default PromiseStatus;